<div class="lui-card-doc-bg"></div>
<ng-content select="lui-card-doc-actions"></ng-content>
<div class="lui-card-doc-content">
  <ng-content></ng-content>
</div>
<ng-content select="mat-divider"></ng-content>
<ng-content select="lui-card-doc-footer"></ng-content>
